import { NgModule } from '@angular/core';
import { FooterLanComponent } from './Layouts/footer/footer.component';
import { HeaderComponent } from './Layouts/header/header.component';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ScrollSpyModule } from 'ngx-scrollspy';
import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';
import { CookieBannerComponent } from './Layouts/cookie-banner/cookie-banner.component';

@NgModule({
    declarations: [
      FooterLanComponent,
      HeaderComponent,
      CookieBannerComponent,
    ],
    imports: [
      CommonModule,
      RouterModule,
      ScrollSpyModule.forRoot(),
      ScrollToModule.forRoot(),
    ],
    exports:[
      FooterLanComponent,
      HeaderComponent
    ]
  })
  export class ComponentsModule { }